if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    async getCartData() {
      try {
        const response = await fetch('/cart.js');
        if (!response.ok) throw new Error('Failed to fetch cart data');
        return await response.json();
      } catch (error) {
        console.error('Error fetching cart data:', error);
        return null;
      }
    }

    async handleClevertapEvents(element, eventName) {
      if (!element) return;
      
      const productId = element.dataset?.productId;
      const productUrl = element.dataset?.productUrl;
      const productTitle = element.dataset?.productTitle;
      const productCategory = element.dataset?.productCategory;
      const toNumber = (v) => Number(String(v ?? 0).replace(/,/g, ''));
      const productPrice = toNumber(element.dataset?.price);
      const productCompareAtPrice = toNumber(element.dataset?.retailPrice);
      let discountPrice = 0;
      if(productCompareAtPrice > productPrice) {
        discountPrice = productCompareAtPrice - productPrice;
      } else {
        discountPrice = 0;
      }
      const pageUrl = window.location.href;
      const pageName = element.dataset?.template;
      let eventData = null;

      if (eventName === 'PDP_ATC' || eventName === 'PDP_ATC_More_flavours' || (eventName === 'PDP_ATC_bestsellers' && pageName === 'product')) {
        const cartData = await this.getCartData();
        const cartTotalQuantity = cartData ? cartData.item_count : 0;
        console.log('pavan');
        eventData = {
          "Product ID": productId,
          "Product Title": productTitle,
          "Product URL": productUrl,
          "Product Price": productPrice,
          "Product Category": productCategory,
          "Discount Price": discountPrice,
          "Page URL": pageUrl,
          "Page Name": pageName,
          "Cart Total Quantity": cartTotalQuantity
        };
      } 
      if (eventData && window.clevertap && window.clevertap.event && typeof window.clevertap.event.push === 'function') {
        window.clevertap.event.push(eventName, eventData);
      }
    }

    handleAddToCartEvents() {
      const isProductPageATC = this.form.querySelector('[data-atc-source="PDP_ATC"]');
      const isProductPageMoreFlavoursATC = this.form.querySelector('[data-atc-source="PDP_ATC_More_flavours"]');
      const isPDPBestSellersATC = this.form.querySelector('[data-atc-source="PDP_ATC_bestsellers"]');

      if (isProductPageATC) {
        this.handleClevertapEvents(isProductPageATC, 'PDP_ATC');
      }
      if (isProductPageMoreFlavoursATC) {
        this.handleClevertapEvents(isProductPageMoreFlavoursATC, 'PDP_ATC_More_flavours');
      }
      if (isPDPBestSellersATC) {
        this.handleClevertapEvents(isPDPBestSellersATC, 'PDP_ATC_bestsellers');
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          this.handleAddToCartEvents();
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          sessionStorage.setItem('popAtc',true);
          renderPopPrices();
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
